import React, { useState } from "react";
import './Nav.css';
import { useLocation, useNavigate } from "react-router-dom";

function Nav() {
  const location = useLocation();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleHomeClick = (e) => {
    e.preventDefault();
    if (location.pathname === "/") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      navigate("/");
    }
    setMenuOpen(false);
  };

  const handleScrollLink = (e, id) => {
    e.preventDefault();
    if (location.pathname !== "/") {
      navigate("/", { replace: true });
      setTimeout(() => scrollToSection(id), 100); // wait for page to load
    } else {
      scrollToSection(id);
    }
    setMenuOpen(false);
  };

  return (
    <header className="navbar-container shadow-sm">
      <nav className="navbar-inner">
        <a href="/" className="navbar-logo" onClick={handleHomeClick}>
          <img src="/assets/images/logo_upself.svg" alt="UPSelf" />
        </a>

        <button className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
          ☰
        </button>

        <ul className={`navbar-links ${menuOpen ? "open" : ""}`}>
          <li><a href="/" onClick={handleHomeClick}>Home</a></li>
          <li><a href="#api" onClick={(e) => handleScrollLink(e, "api")}>How it works</a></li>
          <li><a href="#mission" onClick={(e) => handleScrollLink(e, "mission")}>Our Mission</a></li>
          <li><a href="#team" onClick={(e) => handleScrollLink(e, "team")}>Our Team</a></li>
          {/* <li><Link to="/swag" onClick={() => setMenuOpen(false)}>Swag Store</Link></li> */}
        </ul>
      </nav>
    </header>
  );
}

export default Nav;
